export default __webpack_public_path__ + "static/media/explore1.8c6d205e.jpeg";